module.exports = __webpack_public_path__ + "img/88da9.691dbfde.svg";